module.exports = __webpack_public_path__ + "static/media/partnerships.bc9f0513.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/ProgramTimeline/img/partnerships.svg
// module id = 236
// module chunks = 0